import React, { Component } from 'react'

class StaticIps extends Component {
  constructor (props) {
    super(props)
    this.state = {
      staticIps: props.value
    }
  }

  render () {
    const { staticIps } = this.state
    return (
      <div className='staticip-field'>
        {
          (staticIps || []).map((sip) => <li>{sip}</li>)
        }
      </div>
    )
  }
}

export { StaticIps }



// WEBPACK FOOTER //
// ./src/components/push_apis/StaticIps.js